import { render, staticRenderFns } from "./order-site-distribution.vue?vue&type=template&id=5177babc&scoped=true&"
import script from "./order-site-distribution.vue?vue&type=script&lang=js&"
export * from "./order-site-distribution.vue?vue&type=script&lang=js&"
import style0 from "./order-site-distribution.vue?vue&type=style&index=0&id=5177babc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177babc",
  null
  
)

export default component.exports